import { render, staticRenderFns } from "./InfoValittuValilehti.vue?vue&type=template&id=48f9bc66&"
import script from "./InfoValittuValilehti.vue?vue&type=script&lang=js&"
export * from "./InfoValittuValilehti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f9bc66')) {
      api.createRecord('48f9bc66', component.options)
    } else {
      api.reload('48f9bc66', component.options)
    }
    module.hot.accept("./InfoValittuValilehti.vue?vue&type=template&id=48f9bc66&", function () {
      api.rerender('48f9bc66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InfoValittuValilehti.vue"
export default component.exports